import * as React from 'react';
import { SVGProps, memo } from 'react';

const NotFoundIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width={193}
    height={200}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.309 87.539s33.964-1.367 41.303-57.461c6.518-49.818 63.79-27.143 80.345-7.284 21.446 25.725 10.014 69.977 37.756 75.567 27.743 5.591 9.627 67.745-32.485 61.796-52.386-7.4-39.712 23.356-55.437 36.375-11.287 9.343-57.564.349-59.106-33.568-1.298-28.54-13.28-28.449-21.773-31.686-12.248-4.667-19.966-38.469 9.397-43.74Z"
      fill="#ECECEC"
    />
    <path
      d="m152.412 158.639-33.369-33.13-6.607 6.719 33.368 33.129 6.608-6.718Z"
      fill="#fff"
    />
    <path
      d="m165.157 167.542-25.961-25.774a.366.366 0 0 0-.52.003l-9.826 9.991a.37.37 0 0 0 .003.523l25.961 25.774a.365.365 0 0 0 .52-.003l9.826-9.991a.372.372 0 0 0-.003-.523Z"
      fill="#D1D1D1"
    />
    <path
      d="M89.468 142.172c22.956 0 41.566-18.698 41.566-41.764 0-23.066-18.61-41.764-41.566-41.764-22.957 0-41.566 18.698-41.566 41.764 0 23.066 18.61 41.764 41.566 41.764Z"
      fill="#fff"
    />
    <path
      d="M89.467 135.358c19.21 0 34.784-15.647 34.784-34.949s-15.574-34.95-34.784-34.95c-19.211 0-34.784 15.648-34.784 34.95 0 19.302 15.573 34.949 34.784 34.949Z"
      fill="#ECECEC"
    />
  </svg>
);

const Memo = memo(NotFoundIcon);
export default Memo;
